<template>
  <v-footer padless>
    <v-row class="ma-0 py-10">
      <v-col class="pa-0" cols="12">
        <v-img
          alt="Vuetify Logo"
          class=""
          contain
          :src="logo"
          transition="scale-transition"
          height="26"
        />
      </v-col>
      <v-col cols="12" class="pa-0 mt-4 text-center">
        <p class="mb-0 address">
          COPYRIGHTⒸ{{ new Date().getFullYear() }} ISU SYSTEM. ALL RIGHTS
          RESERVED.
        </p>
        <p class="mb-0 address">
          <Policy :routeParam="$route.params"></Policy>
        </p>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import { getJson } from '@/api/network';
import Policy from '@/views/Policy.vue';
export default {
  components: {
    Policy,
  },
  name: 'RecFooter',
  data() {
    return {
      logo: '',
      tenantKey: '',
    };
  },
  created() {
    this.tenantKey = this.$store.getters.tenantKey;
    this.setLogo();
  },
  methods: {
    logout() {
      this.$store.commit('logout');
      this.$router.push('/login/' + this.tenantKey);
    },
    setLogo: function() {
      this.logo = ''; //require(`@/img/login/logo_header_${this.$route.params.tenantKey}.png`);
      getJson('api/' + this.$route.params.tenantKey + '/image/footer', {})
        .then(res => {
          if (
            res &&
            res.data &&
            res.data.hasOwnProperty('image') &&
            res.data.image &&
            res.data.image != ''
          ) {
            this.logo = res.data.image;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
/*
.v-application p {
  color: #999999;
  margin-bottom: 0px;
}
*/

.v-subheader.policy-wrapper {
  height: 26px;
}
.v-application a {
  color: #555555 !important;
  text-decoration: none;
}

/* for mobile */
@media (max-width: 768px) {
  .v-subheader.policy-wrapper {
    height: auto;
  }
}

.v-footer {
  background-color: #fff !important;
}

.v-footer .address {
  font-size: 14px;
  line-height: 1.3;
  color: #666666;
}

.v-footer .privacy-btn {
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: -0.28px !important;
  color: #363c43 !important;
}
</style>
